import { render, staticRenderFns } from "./fire-fighting.vue?vue&type=template&id=2cb61db9&scoped=true&"
import script from "./fire-fighting.vue?vue&type=script&lang=js&"
export * from "./fire-fighting.vue?vue&type=script&lang=js&"
import style0 from "./fire-fighting.vue?vue&type=style&index=0&id=2cb61db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb61db9",
  null
  
)

export default component.exports